module.exports = __webpack_public_path__ + "img/product_02.a1d11c3.webp";